import script from "./UtilityBillsView.vue?vue&type=script&setup=true&lang=js"
export * from "./UtilityBillsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__